import { Box, Group, Switch, Transition } from '@mantine/core';
import { useEffect } from 'react';
import Tooltip from 'src/components/UI/Tooltip/Tooltip';
import Text from '@ui/components/Text/Text';
import Icon from '@ui/components/Icon/Icon';
import ShareLinkButton from 'src/components/ShareLinkButton/ShareLinkButton';
import GuestHash from '@projects/models/guestHash';

import useInviteLink from './useInviteLink';

type InviteLinkProps = {
	projectID: number;
	guestHash: GuestHash;
	onInviteLinkChange?: ( guestHash: GuestHash ) => void;
}

const InviteLink = ( { projectID, guestHash, onInviteLinkChange }: InviteLinkProps ) => {
	const {
		showSuccessMessage,
		copyShareLink,
		boxStyles,
		onLinkEnabledToggled
	} = useInviteLink( { guestHash, projectID } );

	useEffect( () => {
		onInviteLinkChange?.( guestHash );
	}, [ guestHash, onInviteLinkChange ] );

	const handleLinkToggled = () => {
		onLinkEnabledToggled();
	};

	return (
		<Group position="apart" px={8} h={36} style={boxStyles} className="InviteLink">
			<Group spacing={6}>
				<Switch
					size="xs"
					checked={guestHash.enabled}
					onChange={handleLinkToggled}
				/>
				<Text variant="footnote" color="var(--color-text-primary)">{guestHash.role.name}</Text>
				<Group spacing={4}>
					<Tooltip
						title={guestHash.role.description}
					>
						<Icon icon="info_outlined" size={14} color="var(--color-text-secondary)" />
					</Tooltip>
				</Group>
			</Group>
			<Transition mounted={guestHash.enabled} transition="fade" duration={400} timingFunction="ease">
				{styles => (
					<Box style={styles}>
						<ShareLinkButton
							showSuccessMessage={showSuccessMessage}
							copyShareLink={copyShareLink}
							disabled={!guestHash.enabled}
						/>
					</Box>
				)}
			</Transition>
		</Group>
	);
};

export default InviteLink;
